/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
"use client";

import React, { useContext, useMemo, useRef } from "react";
import { Carousel } from "@arco-design/web-react";
import Image from "next/image";
import "./index.scss";
import useElementExposure from "@/hooks/useElementExposure";
import { LoginContext } from "@/app/LoginProvider";
import { GetTrackingRecordSaveParams } from "@/api/track/interface";
import {
  TrackingEventID,
  TrackingEventPageID,
  TrackingEventType,
} from "@/shared";
import { ABOUT_US_TT_INTRO_LIST } from "@/cdn-resources";

const BannerPage: React.FC = () => {
  return (
    <Carousel
      className={"yf-choose-banner-carousel"}
      autoPlay={{ interval: 3000 }}
      showArrow="never"
      indicatorType="line"
      animation="card"
      indicatorPosition="outer"
    >
      {ABOUT_US_TT_INTRO_LIST.map((src, index) => (
        <div key={index} className="yf-choose-banner-carousel-item">
          <img src={src} alt="tt-intro" />
        </div>
      ))}
    </Carousel>
  );
};

const reasons = [
  "Earn more than the standard 5% commission",
  "Access to top brand products with over 1,000,000 reviews",
  "Moderation completed in just 1 minute",
  "Receive product samples in 3 days",
  "Incentive & heating policy with bonuses up to 1,000,000",
];

const ChooseUsPage: React.FC = () => {
  const loginCtx = useContext(LoginContext);
  const trackParam = useMemo<GetTrackingRecordSaveParams>(() => {
    return {
      uid: loginCtx?.userInfo?.uid,
      event_id: TrackingEventID.AboutUsExposure,
      event_type: TrackingEventType.Exposure,
      page_id: TrackingEventPageID.AboutUs,
    };
  }, [loginCtx?.userInfo?.uid]);

  const domRef = useRef<HTMLDivElement>(null);
  useElementExposure(domRef, trackParam, true);

  return (
    <div className="py-[100px] relative w-full bg-white yf-intro" ref={domRef}>
      <div className="flex justify-center w-full">
        <BannerPage />
        <div className="mt-24 ml-20 intro-right">
          <h1>Why KOLs Love YooFinds?</h1>
          <ul className="yf-choose-list text-textColor">
            {reasons.map((item) => (
              <li className="flex items-baseline" key={item}>
                <span className="circle" /> {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="flex justify-center gap-x-20 mt-20">
        <div>
          <h1 className="font-bold">60%</h1>
          <p>Increase in items sold with YooFinds</p>
        </div>
        <div>
          <h1 className="font-bold">50%</h1>
          <p>Increase in 1 Month after using YooFinds</p>
        </div>
        <div>
          <h1 className="font-bold">300%</h1>
          <p>Increase in revenue in 3 Month</p>
        </div>
      </div>
      <Image
        src="https://cdn-01.yolobuyer.com/pc/about_us/yf-app-QRcode.png"
        width={185}
        height={196}
        alt="YooFinds App QRcode"
        title="YooFinds App QRcode"
        className="yf-app-QRcode-icon"
      />
    </div>
  );
};

export default ChooseUsPage;
